import { render, staticRenderFns } from "./addTaxe.vue?vue&type=template&id=0c8392e6"
import script from "./addTaxe.vue?vue&type=script&lang=js"
export * from "./addTaxe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports